import { render, staticRenderFns } from "./ItemGroupOption.vue?vue&type=template&id=0013c813&"
import script from "./ItemGroupOption.vue?vue&type=script&lang=ts&"
export * from "./ItemGroupOption.vue?vue&type=script&lang=ts&"
import style0 from "./ItemGroupOption.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports